module.exports = __webpack_public_path__ + "img/select-date.40010b47.png";